import { ModalCustom } from "components/ModalCustom";

import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

interface IListarProxy {
  id: number;
  proxy: string;
  fornecedor: string;
  quantidade_falhas: number;
  exclusao: number;
  bloqueado?: boolean;
  utilizado?: boolean;
}

interface IModalListaProxyProps {
  show: boolean;
  handleClose: () => void;
  dados: IListarProxy[];
  totalRows: number;
}

export function ModalListaProxy({
  show,
  handleClose,
  dados,
}: IModalListaProxyProps) {
  const [fornecedorFiltro, setFornecedorFiltro] = useState<string>("");

  const fornecedores = useMemo(
    () =>
      Array.from(
        new Set(dados.map(({ fornecedor }) => fornecedor).filter(Boolean))
      ).sort(),
    [dados]
  );

  const dadosFiltrados = useMemo(
    () =>
      fornecedorFiltro
        ? dados.filter(({ fornecedor }) => fornecedor === fornecedorFiltro)
        : dados,
    [dados, fornecedorFiltro]
  );

  const columns: IColum<IListarProxy>[] = [
    {
      name: <span>Proxy</span>,
      selector: ({ proxy }: IListarProxy) => proxy,
    },
    {
      name: <span>Fornecedor</span>,
      selector: ({ fornecedor }: IListarProxy) => fornecedor ?? "-",
    },
    {
      name: <span>Quantidade Falhas</span>,
      selector: ({ quantidade_falhas }: IListarProxy) => quantidade_falhas,
    },
    {
      name: <span>Bloqueado</span>,
      selector: ({ bloqueado }: IListarProxy) => (bloqueado ? "Sim" : "Não"),
    },
    {
      name: <span>Utilizado</span>,
      selector: ({ utilizado }: IListarProxy) => (utilizado ? "Sim" : "Não"),
    },
  ];

  const customTableStyle = {
    table: {
      style: {
        maxHeight: "70vh",
        overflowY: "auto",
      },
    },
    rows: {
      style: {
        height: "auto",
        padding: "10px 1px",
      },
    },
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Lista Proxy"
      centered
      size="lg"
    >
      <div>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Fornecedor</Form.Label>
            <Form.Select
              value={fornecedorFiltro}
              onChange={(event) => setFornecedorFiltro(event.target.value)}
            >
              <option value="">Todos</option>
              {fornecedores.map((fornecedor) => (
                <option key={fornecedor} value={fornecedor}>
                  {fornecedor}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <Table
          customTableStyle={customTableStyle}
          keyField="id"
          totalRows={dadosFiltrados.length}
          noSubHeader
          columns={columns}
          data={dadosFiltrados}
          loading={false}
        />
      </div>
    </ModalCustom>
  );
}
